module.exports = __webpack_public_path__ + "img/15.093c064a.png";